/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type {OfrepBulkResponse} from '../models/OfrepBulkResponse';
import type {OfrepRequest} from '../models/OfrepRequest';
import type {OfrepSingleResponse} from '../models/OfrepSingleResponse';
import type {CancelablePromise} from '../core/CancelablePromise';
import type {BaseHttpRequest} from '../core/BaseHttpRequest';
export class OpenFeatureService {
  constructor(public readonly httpRequest: BaseHttpRequest) {}
  /**
   * Single feature flag evaluation.
   * @returns OfrepSingleResponse OK
   * @throws ApiError
   */
  public openFeatureEvaluateFlag({
    flagKey,
    requestBody,
  }: {
    flagKey: string;
    requestBody: OfrepRequest;
  }): CancelablePromise<OfrepSingleResponse> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/api/open-features/ofrep/v1/evaluate/flags/{flagKey}',
      path: {
        flagKey: flagKey,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * Bulk feature flag evaluation.
   * @returns OfrepBulkResponse OK
   * @throws ApiError
   */
  public openFeatureBulkEvaluateFlag({
    requestBody,
  }: {
    requestBody: OfrepRequest;
  }): CancelablePromise<OfrepBulkResponse> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/api/open-features/ofrep/v1/evaluate/flags',
      body: requestBody,
      mediaType: 'application/json',
    });
  }
}
